import React, { useState } from 'react';

import { RenderQuestion } from 'Components/organisms';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function AddRemoveInputComponent() {
  const [min, setMin] = useState(2);
  const [max, setMax] = useState(10);
  const [minEvent, setMinEvent] = useState(2);
  const [maxEvent, setMaxEvent] = useState(10);
  const [letter, setLetter] = useState('');
  const [form, setForm] = useState({
    eventOrders: [
      { sequence: 0, title: '', description: '' },
      { sequence: 1, title: '', description: '' },
    ],
    questions: [
      {
        sequence: 0,
        question: '테스트1',
        necessary: true,
      },
      { sequence: 1, question: '테스트2', necessary: true },
      {
        sequence: 2,
        question: '테스트3',
        necessary: false,
      },
    ],
  });
  const [defaultQuestion] = useState({
    sequence: 0,
    question: '추가 질문이 없어요.',
    necessary: false,
  });
  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  return (
    <div className={cx('question-add-remove')}>
      최소 input 개수 :{' '}
      <input
        placeholder="최소 값"
        value={min}
        onChange={(e) => {
          setMin(e.target.value);
        }}
      />
      <br />
      최대 input 개수 :{' '}
      <input placeholder="최대 값" value={max} onChange={(e) => setMax(e.target.value)} />
      <br />
      {form.questions.map((moreQuestion, index) => {
        return (
          <RenderQuestion
            key={index}
            type="guestQuestion"
            no={index + 1}
            index={index}
            item={moreQuestion}
            requireCheck
            onAddDelete={(value) => {
              let arrQuestion = form.questions;
              value > 0
                ? arrQuestion.splice(index + 1, 0, {
                    question: '',
                    necessary: false,
                  })
                : arrQuestion.splice(index, 1);
              form.questions = arrQuestion;
              handleChange('questions', form.questions);
            }}
            onQuestionChange={(question, checkBox) => {
              console.log(form.questions[index]);
              const newInputContent = {
                sequence: form.questions[index].sequence,
                question: question,
                necessary: checkBox,
              };
              form.questions[index] = newInputContent;
              handleChange('questions', form.questions);
            }}
            minCount={form.questions.length <= min}
            maxCount={form.questions.length >= max}
          />
        );
      })}
      {form.questions.length === 0 && (
        <RenderQuestion
          type="guestQuestion"
          no={1}
          index={0}
          item={defaultQuestion}
          requireCheck
          onAddDelete={(value) => {
            let arrQuestion = form.questions;
            value > 0
              ? arrQuestion.splice(index + 1, 0, {
                  question: '',
                  necessary: false,
                })
              : arrQuestion.splice(index, 1);
            form.questions = arrQuestion;
            handleChange('questions', form.questions);
          }}
          disables
          noQuestions
          minCount={form.questions.length <= min}
          maxCount={form.questions.length >= max}
        />
      )}
      <hr />
      최소 input 개수 :{' '}
      <input
        placeholder="최소 값"
        value={minEvent}
        onChange={(e) => {
          setMinEvent(e.target.value);
        }}
      />
      <br />
      최대 input 개수 :{' '}
      <input placeholder="최대 값" value={maxEvent} onChange={(e) => setMaxEvent(e.target.value)} />
      <br />
      {form.eventOrders.map((eventOrder, index) => {
        return (
          <RenderQuestion
            key={index}
            type="eventOrder"
            no={index + 1}
            index={index}
            item={eventOrder}
            minCount={form.eventOrders.length <= minEvent}
            maxCount={form.eventOrders.length >= maxEvent}
            onAddDelete={(value) => {
              let arrEventOrder = form.eventOrders;
              value > 0
                ? arrEventOrder.splice(index + 1, 0, {
                    title: '',
                    description: '',
                  })
                : arrEventOrder.splice(index, 1);

              form.eventOrders = arrEventOrder;
              handleChange('eventOrders', form.eventOrders);
            }}
            onEventOrderChange={(t, d) => {
              const newInputContent = {
                sequence: form.eventOrders[index].sequence,
                title: t,
                description: d,
              };
              form.eventOrders[index] = newInputContent;
              handleChange('eventOrders', form.eventOrders);
            }}
            subInput
            charCount
          />
        );
      })}
    </div>
  );
}
export default AddRemoveInputComponent;

export const path = '/input_add_remove';
